import "../graphStyles.scss";
import { useEffect, useState } from "react";
import TempDropDown from "./TempDropDown";
import { useSelector } from "react-redux";

const calcPercentage = (total, obtain) => {
  if (total <= 0) return 0;
  else return Math.round((obtain * 100) / total, 2);
};

export default function CouponsWisePerformance({ weeks, data }) {
  // console.log(weeks, data)
  const [currentWeek, setCurrentWeek] = useState(weeks[0] ?? "");
  const [currentWeekData, setCurrentWeekData] = useState(data[currentWeek] ?? []);
  const DBNudgeName = useSelector((state) => state.nudgeCoupon.nudgeKeyName);
  // console.log("DBNudgeName", DBNudgeName);

  function getNudgeName(nudgeId) {
    if (!nudgeId || !Array.isArray(DBNudgeName)) return "";
  
    const match = DBNudgeName.find((item) => item.optionValue.toLowerCase() === nudgeId);
    return match?.optionName ;
    // return match?.optionName || nudgeId;
  }

  useEffect(() => {
    setCurrentWeekData(data[currentWeek]);
  }, [currentWeek])

  useEffect(() => {
    if (data[currentWeek]) {
      setCurrentWeekData(
        data[currentWeek].map((row) => ({
          ...row,
          nudgeName: getNudgeName(row.nudgeId) || ""
        }))
      );
    }
  }, [DBNudgeName, currentWeek]);

  console.log("currentWeekData", currentWeekData);


  return (
    <div className="graph flex flex-col">
      <div className="graph__title">
        <h4>Coupons-wise performance</h4>
        <TempDropDown currentWeek={currentWeek} setCurrentWeek={setCurrentWeek} weeks={weeks} />
      </div>
      <div className="overflow-auto">
        <table className="p-1 min-w-full divide-y divide-gray-300 border rounded-lg overflow-auto max-h-[100px]">
          <thead>
            <tr className="divide-x divide-gray-300">
              <th
                scope="col"
                className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900"
              >
                Nudge name
              </th>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900"
              >
                Coupon code
              </th>
              <th
                scope="col"
                className="px-4 py-3.5 text-left text-sm font-semibold text-gray-900"
              >
                Coupons shown
              </th>
              <th
                scope="col"
                className="px-4 py-3.5 text-left text-sm font-semibold text-gray-900"
              >
                Added to cart (via coupon shown)
              </th>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pr-0"
              >
                Sales done (via coupon added to cart)
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-300 bg-white">
            {currentWeekData?.map((persona, index) => (
              <tr key={index} className="divide-x divide-gray-300">
              <td className="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 ">
                {persona.nudgeName}
              </td>
              <td className="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 ">
                {persona.couponCode}
              </td>
              <td className="whitespace-nowrap p-4 text-sm text-gray-600">
                {persona.couponShown}{" "}
              </td>

              <td className="whitespace-nowrap py-4 pl-4 pr-4 text-sm text-gray-600 ">
                <div className="flex justify-center gap-3 items-center">
                  <span>{persona.couponAddToCart}</span>
                  <span className="inline-flex items-center gap-x-1.5 rounded-full bg-yellow-100 px-2 py-1 text-xs font-medium text-yellow-800">
                    <svg
                      className="h-1.5 w-1.5 fill-yellow-500"
                      viewBox="0 0 6 6"
                      aria-hidden="true"
                    >
                      <circle cx={3} cy={3} r={3} />
                    </svg>
                    {calcPercentage(
                      persona.couponShown,
                      persona.couponAddToCart
                    )}
                    %
                  </span>
                </div>
              </td>
              <td className="whitespace-nowrap py-4 pl-4 pr-4 text-sm text-gray-600 ">
                <div className="flex justify-center gap-3 items-center">
                  <span>{persona.couponSalesDone}</span>
                  <span className="inline-flex items-center gap-x-1.5 rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-800">
                    <svg
                      className="h-1.5 w-1.5 fill-green-500"
                      viewBox="0 0 6 6"
                      aria-hidden="true"
                    >
                      <circle cx={3} cy={3} r={3} />
                    </svg>
                    {calcPercentage(
                      persona.couponAddToCart,
                      persona.couponSalesDone
                    )}
                    %
                  </span>
                </div>
              </td>
            </tr>
            ))}
          </tbody>
        </table> 
      </div>
    </div>
  );
}
